import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import uuidv4 from 'uuid/v4';
import { validateSaleSuccess } from '../../validated/actions';
import { getOrderForValidation } from '../../selectors';
import withValidateSaleAction from '../../hoc/withValidateSaleAction';
import { assignPayments } from '../reducer/payments/actions';
import { getPayments } from '../reducer/payments/selectors';
import { setFetching } from '../reducer/isFetching/actions';

const withAddPayment = compose(
  withValidateSaleAction,
  connect(
    state => ({
      order: getOrderForValidation(state),
      payments: getPayments(state),
    }),
    { assignPayments, setFetching, validateSaleSuccess },
  ),
  withHandlers({
    validatePayment: props => payment => props.validateSaleAction({
      ...props.order,
      payments: [
        ...props.order.payments,
        payment,
      ],
    }),
  }),
  withHandlers({
    addPayment: props => (payment, onError = () => {}) => {
      props.setFetching(true);
      const paymentWithId = { ...payment, id: uuidv4() };
      return props.validatePayment(paymentWithId)
        .then((response) => {
          props.assignPayments([...props.payments, paymentWithId]);
          props.validateSaleSuccess(response);
          props.setFetching(false);
          return null;
        })
        .catch((err) => {
          onError(err);
          return props.setFetching(false);
        });
    },
  }),
);

export default withAddPayment;
